import { MuiThemeProvider } from '@material-ui/core/styles';
import { createBrowserHistory } from 'history';
import * as React from 'react';
import { Route, Router, Switch } from 'react-router';
import '../assets/App.css';
import indexRoutes from '../routes/index';
import defaultTheme from './../materialTheme';
// import Header from './Header';
import Footer from './Footer';
import { SilentScroller } from './SilentScroller';

const hist = createBrowserHistory();

export class App extends React.Component {
	public render() {
		return (
			<SilentScroller>
				<Router history={hist}>
					<MuiThemeProvider theme={defaultTheme}>
						{/* <Header /> */}
						<div style={{backgroundColor: defaultTheme.palette.primary.dark}}>
						<Switch>
							{indexRoutes.map((prop, key) => {
								return <Route path={prop.path} key={key} component={prop.component} />;
							})}
						</Switch>
						</div>
						<Footer />
					</MuiThemeProvider>
				</Router>
			</SilentScroller>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/App.tsx